// frontend/src/components/UI/CookiePopup.js

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookiePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed bottom-4 left-4 right-4 bg-white border border-accent rounded-lg shadow-lg p-4 flex flex-col md:flex-row items-center justify-between z-50"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
        >
          <p className="mb-2 md:mb-0">
            Wir verwenden Cookies, um Ihr Erlebnis zu verbessern. Wenn Sie fortfahren, stimmen Sie unserer Verwendung von Cookies zu.
          </p>
          <button
            onClick={acceptCookies}
            className="bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 transition"
          >
            Akzeptieren
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookiePopup;
